<template lang="pug">
    .settings(v-if='settings')
        template(v-if="parametersFrom === 'homework'")
            | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}:
            | {{ settings.amountOfExamples }}
            br
            template(v-if='settings.difficulties')
                | {{ $i18n.t('trainer.trainer_gameFormSetting_difficulty') }}:
                | {{ digitCapacityNames[settings.difficulties[settings.difficulties.length - 1]] }}
                template(v-if='settings.fractions')
                    br
                    span
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_fractions') }}:
                        | {{ getFractionalPart() }}
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_afterPoint') }}
                br
        template(v-else)
            template(v-if="digitCapacity")
                | {{ $i18n.t('trainer.trainer_gameFormSetting_divisibleMultiplier') }}:
                | {{ digitCapacity[number] }}
                span(v-if='settings.fractions')
                    br
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_fractions') }}:
                    | {{ getFractionalPart() }}
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_afterPoint') }}
                br
        | {{ $i18n.t('trainer.trainer_gameFormSetting_operations') }}: {{ field('operations') }}
        br
        template(v-if="areExtraOperationsEnabled")
            | {{ $i18n.t('trainer.trainer_gameFormSetting_extraOperations') }}: {{ field('extraOperations') }}
        br
        slot
</template>

<script>
    import preview from '../../../utils/roots-and-degrees/preview';
    export default {
        props: {
            game: Object,
            parameters: Object,
            parametersFrom: {
                type: String,
                default: 'homework',
            },
            userId: Number,
        },
        mixins: [preview],
        methods: {
            getFractionalPart() {
                return (
                    this.settings.fractionalPart +
                    ' ' +
                    this.$i18n.tc('trainer.trainer_gamePreview_numDeclination', this.settings.fractionalPart)
                );
            },
        },
    };
</script>
